import { dispatchProps } from "../cnr/reducers/reducerHelpers/dispatchProps";
import { createRefPath_event } from '../firestoreData/appData/appRefPaths';

export const fsfn_updateStaticViews = async (pathViews, viewItem, viewListData, staticName, fixedStaticView, appUserViewTypeProp, dispatch) => {
  const staticProps = ['email', 'startDate', 'endDate', 'startTime', 'departureTime', 'endTime', 'parents', 'gender']
  staticProps.push(appUserViewTypeProp)
  try {
    const _refPath = createRefPath_event(pathViews, ['staticViews', staticName])
    database_fns.set_doc(_refPath, viewListData, false, dispatch)
  } catch (error) {
    dispatch && dispatch({ type: dispatchProps.error, error })
  }
}

export const fsfn_convertToParentKeys = async (aps_viewItems, paps_state) => {
  const data = {}
  try {
    console.log('data', data)
  } catch (error) {
    console.error(error)
  }
}
